import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {PriceLevelReferenceData} from "./price-level.data";

@Injectable()
export class PriceLevelSearchModel extends SearchModel<PriceLevelReferenceData> {
    public static readonly EXCLUDE_PRICE_LEVEL_ID_FILTER_NAME: string = "excludePriceLevelId";
    public static readonly ACTIVE_PRICE_LEVEL: number = -1;

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "priceLevelId"
    }
}
